import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入样式
import '@/assets/styles/init.css'
import '@/assets/styles/font.scss'
import '@/assets/styles/theme.scss'

// 自适应适配
import "amfe-flexible/index";

// 引入 Element-Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
